import { Box, CircularProgress, Fade } from "@mui/material";

/**
 * Shown while a page's code loads. It fades in only after a moment, so a quick load doesn't
 * flash a spinner.
 */
export default function PageLoading() {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
      <Fade in style={{ transitionDelay: "400ms" }}>
        <CircularProgress size={28} aria-label="Seite wird geladen" />
      </Fade>
    </Box>
  );
}
